<template>
  <ShippersDeclarationComponent :item="declaration"/>
</template>
<script>

import VueHtml2pdf from 'vue-html2pdf'
import ShippersDeclarationComponent from "@/components/ShippersDeclarationComponent.vue";
import ShippersDeclarationModel from "@/models/ShippersDeclarationModel";
import CompoundCoursePart from "@/models/CompoundCoursePart";
import Vue from "vue";

export default {
  name: "ShippersDeclarationSite",
  components: {
    ShippersDeclarationComponent,
  },
  data: () => ({
    declaration: new ShippersDeclarationModel({})
  }),
  props: {
    item: {
      type: CompoundCoursePart
    }
  },
  methods: {
  }
}
</script>


<style scoped>
.container {
  border-style: solid;
  border-width: 2px;
  border-bottom: 0;
  border-right: 0;
}

.rightborder {
  border-style: solid;
  border-width: 2px;
  border-bottom: 0;
}

.w50 {
  width: 50%;
}

.w60 {
  width: 60%;
}

.w40 {
  width: 40%;
}
</style>
